import React, { useState } from "react";
import Modal from "react-bootstrap/Modal";
import { Button, Form, FormGroup, Label, Input, FormText } from "reactstrap";
import { Row, Col } from "react-bootstrap";
import { useNavigate } from "react-router-dom";

// modal
import Selecttokenmod from "Component/Modals/Selecttokenmod";

export default function BCtowalletmod(props) {
  const navigate = useNavigate();
  const [selecttoken, setselectoken] = useState(false);
  return (
    <>
      <Selecttokenmod show={selecttoken} onHide={() => setselectoken(false)} />
      <Modal
        {...props}
        size="md"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        className="BCtwalletmod"
      >
        <Modal.Body>
          <div className="trassaction_mod_inner position-relative">
            <a
              href="javascript:void(0)"
              className="arrow-back d-flex align-items-center gap-2"
              onClick={props.onhide}
            >
              <span className="me-2">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="30"
                  height="30"
                  viewBox="0 0 40 30"
                  fill="none"
                >
                  <g clip-path="url(#clip0_48_5634)">
                    <path
                      d="M3.23437 13.2344C2.25781 14.2109 2.25781 15.7969 3.23437 16.7734L15.7344 29.2734C16.7109 30.25 18.2969 30.25 19.2734 29.2734C20.25 28.2969 20.25 26.7109 19.2734 25.7344L11.0312 17.5L35 17.5C36.3828 17.5 37.5 16.3828 37.5 15C37.5 13.6172 36.3828 12.5 35 12.5L11.0312 12.5L19.2656 4.26562C20.2422 3.28906 20.2422 1.70312 19.2656 0.72656C18.2891 -0.250003 16.7031 -0.250003 15.7266 0.72656L3.22656 13.2266L3.23437 13.2344Z"
                      fill="black"
                    />
                  </g>
                  <defs>
                    <clipPath id="clip0_48_5634">
                      <rect
                        width="30"
                        height="40"
                        fill="white"
                        transform="translate(0 30) rotate(-90)"
                      />
                    </clipPath>
                  </defs>
                </svg>
              </span>

              <h4 className="m-0">{props.title}</h4>
            </a>

            <div className="buy_crypto_list">
              <Form>
                <ul className="mt-4 p-0 position-relative">
                  <li>
                    <FormGroup className="input_here_wrap">
                      <div className="input_wrapaa d-flex align-items-center justify-content-between">
                        <div className="input_labelaa">
                          <p className="m-0">You Send</p>
                          <h5 className="spend_value m-0">150</h5>
                        </div>

                        <div className="max-here">
                          <div className="payflag-withname d-flex align-items-center gap-2">
                            <img
                              src="/images/flag.png"
                              alt=""
                              className="img-fluid"
                            />
                            <p className="m-0">USD</p>
                          </div>
                        </div>
                      </div>
                    </FormGroup>
                  </li>

                  <li>
                    <div className="buymethod_list d-flex align-items-center ">
                      <div className="grayicon grayiconsm me-3"></div>

                      <div className="radio_tabs">
                        <p className="m-0">Using payment method</p>
                        <div className="payment_select plans pb-3">
                          <label className="plan basic-plan" for="cardpayment">
                            <input
                              checked
                              type="radio"
                              name="plan"
                              id="cardpayment"
                            />
                            <div class="plan-content">
                              <div className="plan-details">
                                <img
                                  src="/images/cardpayment.png"
                                  alt=""
                                  className="img-fluid"
                                />
                              </div>
                            </div>
                          </label>

                          <label className="plan complete-plan" for="applepay">
                            <input type="radio" id="applepay" name="plan" />
                            <div className="plan-content">
                              <div className="plan-details">
                                <img
                                  src="/images/applepay.png"
                                  alt=""
                                  className="img-fluid"
                                />
                              </div>
                            </div>
                          </label>

                          <label className="plan complete-plan" for="gpay">
                            <input type="radio" id="gpay" name="plan" />
                            <div className="plan-content">
                              <div className="plan-details">
                                <img
                                  src="/images/gpay.png"
                                  alt=""
                                  className="img-fluid"
                                />
                              </div>
                            </div>
                          </label>



                        </div>
                      </div>
                    </div>
                  </li>

                  <li>
                    <div className="buymethod_list d-flex align-items-center ">
                      <div className="grayicon me-3">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="28"
                          height="28"
                          viewBox="0 0 28 28"
                          fill="none"
                        >
                          <circle cx="14" cy="14" r="14" fill="#D9D9D9" />
                          <path
                            opacity="0.5"
                            d="M8.57542 13.4757L9.75603 15.5205L5.19598 18.1533L5.7739 19.1897L10.3493 16.5481L11.5269 18.5878L12.6073 14.556L8.57542 13.4757Z"
                            fill="black"
                          />
                          <path
                            opacity="0.5"
                            d="M16.5561 8.64158L17.7367 10.6864L22.2968 8.0537L22.9053 9.07239L18.33 11.714L19.5076 13.7537L15.4758 12.6734L16.5561 8.64158Z"
                            fill="black"
                          />
                        </svg>
                      </div>
                      <p className="m-0">See Fees calculation</p>
                    </div>
                  </li>

                  <li>
                    <div className="buymethod_list d-flex align-items-center ">
                      <div className="grayicon me-3">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="28"
                          height="28"
                          viewBox="0 0 28 28"
                          fill="none"
                        >
                          <circle cx="14" cy="14" r="14" fill="#D9D9D9" />
                          <line
                            opacity="0.5"
                            x1="4"
                            y1="14.5"
                            x2="24"
                            y2="14.5"
                            stroke="black"
                          />
                        </svg>
                      </div>
                      <p className="m-0">14.73 USD Total fees</p>
                    </div>
                  </li>

                  <li>
                    <div className="buymethod_list d-flex align-items-center ">
                      <div className="grayicon me-3">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="24"
                          height="24"
                          viewBox="0 0 24 24"
                          fill="none"
                        >
                          <g opacity="0.5">
                            <path
                              d="M7 11.25H17V12.75H7V11.25ZM12.0014 6C11.6225 5.9996 11.259 6.15726 10.9909 6.43828C10.7227 6.7193 10.5718 7.10068 10.5714 7.4985C10.571 7.89633 10.7212 8.27801 10.9888 8.5596C11.2565 8.84119 11.6197 8.9996 11.9986 9C12.3775 9.0004 12.741 8.84274 13.0091 8.56172C13.2773 8.2807 13.4282 7.89933 13.4286 7.5015C13.429 7.10368 13.2788 6.72199 13.0112 6.4404C12.7435 6.15882 12.3803 6.0004 12.0014 6ZM12.0014 15C11.6225 14.9996 11.259 15.1573 10.9909 15.4383C10.7227 15.7193 10.5718 16.1007 10.5714 16.4985C10.571 16.8963 10.7212 17.278 10.9888 17.5596C11.2565 17.8412 11.6197 17.9996 11.9986 18C12.3775 18.0004 12.741 17.8427 13.0091 17.5617C13.2773 17.2807 13.4282 16.8993 13.4286 16.5015C13.429 16.1037 13.2788 15.722 13.0112 15.4404C12.7435 15.1588 12.3803 15.0004 12.0014 15Z"
                              fill="black"
                            />
                          </g>
                        </svg>
                      </div>
                      <p className="m-0">1949.88 USD = 1 ETH Rate</p>
                    </div>
                  </li>

                  <li>
                    <FormGroup className="input_here_wrap">
                      <div className="input_label">
                        <p>You Recive (estimate)</p>
                      </div>

                      <div className="input_wrap">
                        <Input
                          type="email"
                          name="email"
                          id="exampleEmail"
                          placeholder="0.0698715"
                        />

                        <div className="max-here">
                          <div className="bitcoin_wrap">
                            <Button
                              className="btn-click"
                              onClick={() => setselectoken(true)}
                            >
                              <img
                                src="/images/yellowbitcoin.png"
                                alt=""
                                className="img-fluid"
                              />
                              <p>BTC</p>
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="30"
                                height="30"
                                viewBox="0 0 30 30"
                                fill="none"
                              >
                                <path
                                  d="M21.625 11.625C21.8542 11.8542 21.9688 12.1458 21.9688 12.5C21.9688 12.8542 21.8542 13.1458 21.625 13.375L15.875 19.125C15.75 19.25 15.6146 19.3387 15.4688 19.3912C15.3229 19.4429 15.1667 19.4687 15 19.4687C14.8333 19.4687 14.6717 19.4375 14.515 19.375C14.3592 19.3125 14.2292 19.2292 14.125 19.125L8.375 13.375C8.14584 13.1458 8.03125 12.8542 8.03125 12.5C8.03125 12.1458 8.14584 11.8542 8.375 11.625C8.60417 11.3958 8.89583 11.2812 9.25 11.2812C9.60417 11.2812 9.89584 11.3958 10.125 11.625L15 16.5L19.875 11.625C20.1042 11.3958 20.3958 11.2812 20.75 11.2812C21.1042 11.2812 21.3958 11.3958 21.625 11.625Z"
                                  fill="#000"
                                />
                              </svg>
                            </Button>
                            <p className="bitcoin_network">Bitcoin Network</p>
                          </div>
                        </div>
                      </div>
                    </FormGroup>
                  </li>
                </ul>

                <Button
                  className="btn_sign_in w-100 btn_theme"
                  onClick={props.togglemodalone}
                >
                  Buy Now
                </Button>
              </Form>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
}
